// カートおすすめ商品のバリエーション選択機能
// エラーが発生してもカート本体の機能(js_cart.js)に影響しないように分離

const recommendCollectionSlider = () => {
  // PCとSPの両方の要素を取得
  const recommendCollections = document.querySelectorAll(
    ".recommend_collection.swiper"
  );
  if (!recommendCollections || recommendCollections.length === 0) return;

  // 各要素に対してSwiperを初期化
  recommendCollections.forEach((recommendCollection) => {
    // 各要素内のページネーション要素を取得
    const paginationEl = recommendCollection.querySelector(".swiper-pagination");
    
    const recommendSwiper = new Swiper(recommendCollection, {
      slidesPerView: 2.2,
      spaceBetween: 8,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 3.2,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 4.2,
          spaceBetween: 8,
        },
        1024: {
          slidesPerView: 4.5,
          spaceBetween: 12,
        },
      },
    });

    // レスポンシブでページネーションの位置を変更（各要素に対して個別に実行）
    const movePaginationWrapper = () => {
      // 現在の要素内のページネーションラッパーを取得
      const paginationWrapper = recommendCollection.querySelector(
        ".js-swiper-pagination-responsive"
      );
      if (!paginationWrapper) return;

      if (window.innerWidth >= 640) {
        // PC用の移動先：現在の要素内の.title内に追加
        const pcDestination = recommendCollection.querySelector(".title");
        if (pcDestination && !pcDestination.contains(paginationWrapper)) {
          pcDestination.appendChild(paginationWrapper);
        }
      } else {
        // SP用の移動先：現在の要素内の一番下に追加
        if (!recommendCollection.contains(paginationWrapper)) {
          recommendCollection.appendChild(paginationWrapper);
        }
      }
    };

    // 初期ロード時に移動を実行
    movePaginationWrapper();

    // ウィンドウリサイズ時に再度実行して、レスポンシブに対応
    window.addEventListener("resize", movePaginationWrapper);
  });

  // 全てのカード（スライド）を取得（すべての要素から）
  const cards = document.querySelectorAll(".recommend_collection.swiper .card");

  cards.forEach((card) => {
    const counterEl = card.querySelector(".counter");
    const upBtn = card.querySelector(".up");
    const downBtn = card.querySelector(".down");

    if (!counterEl || !upBtn || !downBtn) return;

    // 現在の数値を取得（初期値は1）
    let count = parseInt(counterEl.textContent, 10) || 1;
    const inventoryMaxAttr = upBtn.getAttribute("data-inventory-max");
    const inventoryMax = inventoryMaxAttr
      ? parseInt(inventoryMaxAttr, 10)
      : 10;

    // 上ボタンのクリックイベント
    upBtn.addEventListener("click", (e) => {
      e.preventDefault();
      if (count >= inventoryMax) {
        upBtn.classList.add("disabled");
        return;
      }

      count++;
      counterEl.textContent = count;
      if (downBtn.classList.contains("disabled")) {
        downBtn.classList.remove("disabled");
      }
    });

    // 下ボタンのクリックイベント（1未満にならないように制御）
    downBtn.addEventListener("click", (e) => {
      e.preventDefault();

      if (count > 1) {
        count--;
        counterEl.textContent = count;
        upBtn.classList.remove("disabled");
      }
    });

    // カート追加ボタンのクリックイベント
    const button = card.querySelector(".card__button");
    if (button) {
      button.addEventListener("click", function (e) {
        e.preventDefault();

        // クリックされたボタンの最も近い.card要素を取得
        const card = this.closest(".card");
        if (!card) return;

        // data-id属性からvariant IDを取得
        const variantId = card.getAttribute("data-id");

        // カウンターの数値を取得（初期値は1）
        const counterEl = card.querySelector(".counter");
        const quantity = parseInt(counterEl.textContent, 10) || 1;

        // ShopifyのAjax APIにPOSTリクエストを送信
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity,
          }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("カート追加リクエストに失敗しました");
            }
            return response.json();
          })
          .then((data) => {
            console.log("カートに追加成功:", data);
            window.location.href = "/cart";
          })
          .catch((error) => {
            console.error("エラー:", error);
          });
      });
    }
  });

  // バリエーション選択イベント
  const variantSelects = document.querySelectorAll('.recommend_collection .variant__select');
  variantSelects.forEach((select) => {
    select.addEventListener('change', function() {
      handleVariantChange(this);
    });
  });
  function handleVariantChange(selectElement) {
    // 選択されたオプション要素をし取得
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    if (!selectedOption) return;
  
    // 選択された最も近い.card要素を取得
    const card = selectElement.closest('.card');
    if (!card) return;
  
    // 選択されたバリエーションの情報を取得
    const variantId = selectedOption.value;
    const variantPrice = selectedOption.getAttribute('data-price');
    const variantImage = selectedOption.getAttribute('data-image');
    const variantInventory = parseInt(selectedOption.getAttribute('data-inventory'), 10) || 0;
  
    // 1. カード要素のdata-id属性を更新（カート追加時に使用）
    card.setAttribute('data-id', variantId);
  
    // 2. 画像を更新
    const imageElement = card.querySelector('.js-variant-image');
    if (imageElement && variantImage) {
      // バリエーション画像がある場合
      imageElement.src = variantImage;
    } else if (imageElement && !variantImage) {
      // バリエーションが画像がない場合　→ 元の商品画像に戻す
      const originalSrc = imageElement.getAttribute('data-original-src');
      if (originalSrc) {
        imageElement.src = originalSrc;
      }
    }
  
    // 3. 価格を更新
    const priceElement = card.querySelector('.js-variant-price .price-value');
    if (priceElement && variantPrice) {
      // 価格をそのまま表示
      priceElement.textContent = variantPrice;
    }
  
    // 4. 在庫数に基づいて数量カウンターの最大値を更新
    const upButton = card.querySelector('.up');
    if (upButton) {
      let inventoryMax = variantInventory;
      if (inventoryMax > 10) {
        inventoryMax = 10;
      }
      upButton.setAttribute('data-inventory-max', inventoryMax);
    }
  
    // 5. 在庫がない場合は追加ボタンを無効化
    const addButton = card.querySelector('.card__button');
    const isAvailable = !selectedOption.disabled;
  
    if (addButton) {
      if (isAvailable) {
        addButton.style.opacity = '1';
        addButton.style.pointerEvents = 'auto';
        addButton.textContent = '追加';
      } else {
        addButton.style.opacity = '0.5';
        addButton.style.pointerEvents = 'none';
        addButton.textContent = '在庫切れ';
      }
    }
  }
};

document.addEventListener("DOMContentLoaded", () => {
  recommendCollectionSlider();
});
